import { useState } from 'react'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'

import { VEHICLE_COMPONENT } from 'features/VehicleTemplates/components/Components/constants'
import { SEAT_STATUS } from './SeatStatus/constants'
import { Cell } from './Cell'
import { OccupiedSeatNotification } from './OccupiedSeatNotification'
import { ErrorSeatNotification } from './ErrorSeatNotification'
import { device } from 'utils/style'

const Wrapper = styled.div<TSFixMe>`
  display: flex;
  justify-content: center;
`

const Floor = styled.div<TSFixMe>`
  padding: 5px 5px 20px;

  @media ${device.laptop} {
    display: flex;
    padding: 5px 20px 5px 5px;
  }
`

const Row = styled.div<TSFixMe>`
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${device.laptop} {
    display: inline-flex;
    flex-direction: column-reverse;
  }
`

const FloorControllerWrapper = styled.div<TSFixMe>`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 300px;
  margin: 0 auto 30px;
  border: 1px solid #1976d2;
  border-radius: 3px;
  overflow: hidden;

  > div {
    width: 0;
    flex: 1 0 auto;
  }
`

const FloorController = styled.div<TSFixMe>`
  text-align: center;
  font-size: 14px;
  color: ${(props): TSFixMe => (props.isActive ? '#ffffff' : '#1976d2')};
  background-color: ${(props): TSFixMe => (props.isActive ? '#1976d2' : '#ffffff')};
  padding: 8px 0;
  cursor: pointer;
`

const getAvailableSeats = (floor: TSFixMe, seats: TSFixMe): TSFixMe => {
  let availableSeats = 0

  floor.forEach((row: TSFixMe): TSFixMe => {
    row.forEach((cell: TSFixMe): TSFixMe => {
      if (cell.component === VEHICLE_COMPONENT.SEAT) {
        const seat = seats.find(({ label }: TSFixMe): TSFixMe => label === cell.label)

        if (seat && seat.status !== SEAT_STATUS.OCCUPIED) {
          availableSeats++
        }
      }
    })
  })

  return availableSeats
}

const isCorridor = (floor: TSFixMe, rowIndex: TSFixMe, cellIndex: TSFixMe): TSFixMe => {
  const currentCell = floor[rowIndex][cellIndex]

  if (rowIndex === 0 && floor.length > 1) {
    const nextCell = floor[rowIndex + 1][cellIndex]
    return nextCell.isEmpty && currentCell.isEmpty
  } else if (rowIndex !== 0) {
    const previousCell = floor[rowIndex - 1][cellIndex]
    return previousCell.isEmpty && currentCell.isEmpty
  }

  return currentCell.isEmpty
}

const getNextTicket = (oldTickets: TSFixMe, newTickets: TSFixMe): TSFixMe => {
  if (newTickets.length < oldTickets.length) {
    const sortedTickets = [...oldTickets].sort((a: TSFixMe, b: TSFixMe): TSFixMe => {
      if (a.seat.label < b.seat.label) return -1
      else if (a.seat.label > b.seat.label) return 1
      else return 0
    })

    return sortedTickets[newTickets.length]
  } else {
    let nextTicket: TSFixMe
    newTickets.forEach((ticket: TSFixMe): TSFixMe => {
      const hasBeenModifiedLater =
        !nextTicket ||
        nextTicket.updatedCount > ticket.updatedCount ||
        (nextTicket.updatedCount === ticket.updatedCount &&
          parseInt(nextTicket.seat.label) > parseInt(ticket.seat.label))

      if (hasBeenModifiedLater) {
        nextTicket = ticket
      }
    })

    return nextTicket
  }
}

export const SeatsTemplate = ({
  vehicleTemplate,
  seats,
  booking,
  oldTickets,
  onStartToReserveSeat,
  tripSegment,
  isModifyingSameTripSegment,
  ...props
}: TSFixMe): TSFixMe => {
  const [currentFloorIndex, setCurrentFloorIndex] = useState(0)
  const [unavailableSeatError, showUnavailableSeatError] = useState(false)
  const [seatError, showSeatError] = useState(false)
  const [isLoading, setLoading] = useState(false)
  const hasSeveralFloors = vehicleTemplate.layout.length > 1
  const currentFloor = vehicleTemplate.layout[currentFloorIndex]
  const nextTicket = getNextTicket(oldTickets, props.values.tickets)

  return (
    <div>
      {hasSeveralFloors && (
        <FloorControllerWrapper>
          <FloorController isActive={currentFloorIndex === 0} onClick={(): TSFixMe => setCurrentFloorIndex(0)}>
            <FormattedMessage
              id="seats.floorController.groundFloor"
              defaultMessage="Planta baja ({availableSeats})"
              values={{
                availableSeats: getAvailableSeats(vehicleTemplate.layout[0], seats)
              }}
            />
          </FloorController>

          <FloorController isActive={currentFloorIndex === 1} onClick={(): TSFixMe => setCurrentFloorIndex(1)}>
            <FormattedMessage
              id="seats.floorController.firstFloor"
              defaultMessage="Primer piso ({availableSeats})"
              values={{
                availableSeats: getAvailableSeats(vehicleTemplate.layout[1], seats)
              }}
            />
          </FloorController>
        </FloorControllerWrapper>
      )}

      <Wrapper>
        <Floor>
          {currentFloor.map((row: TSFixMe, rowIndex: TSFixMe): TSFixMe => {
            return (
              <Row key={rowIndex}>
                {row.map((cell: TSFixMe, cellIndex: TSFixMe): TSFixMe => {
                  return (
                    <Cell
                      key={cellIndex}
                      component={cell.component}
                      isCorridor={isCorridor(currentFloor, rowIndex, cellIndex)}
                      label={cell.label}
                      seat={seats.find(({ label }: TSFixMe): TSFixMe => label === cell.label)}
                      booking={booking}
                      nextTicket={nextTicket}
                      oldTickets={oldTickets}
                      ticket={props.values.tickets.find((ticket: TSFixMe): TSFixMe => {
                        return ticket.seat.label === cell.label
                      })}
                      showUnavailableSeatError={showUnavailableSeatError}
                      showSeatError={showSeatError}
                      onStartToReserveSeat={onStartToReserveSeat}
                      tripSegment={tripSegment}
                      setLoading={setLoading}
                      isModifyingSameTripSegment={isModifyingSameTripSegment}
                      {...props}
                      loading={isLoading || props.loading}
                    />
                  )
                })}
              </Row>
            )
          })}
        </Floor>
      </Wrapper>

      {unavailableSeatError && <OccupiedSeatNotification onClose={(): TSFixMe => showUnavailableSeatError(false)} />}

      {seatError && <ErrorSeatNotification onClose={(): TSFixMe => showSeatError(false)} />}
    </div>
  )
}
